export default __webpack_public_path__ + "static/media/broker-template-3-fr.16815a53.svg";